var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1200 0L0 0 598.97 114.72 1200 0z","className":"shape-fill","fill":"#4facf7","fillOpacity":"1"}));
}

Triangle.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 1200 120","preserveAspectRatio":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
